export default __webpack_public_path__ + "static/media/Wall_Door_Left_Grey.64.656c21cf.png";